import loginAdminImg from "assets/img/admin_img.jpg";
import iconImg from "assets/img/logo-header.png";
import sideBarImg from "assets/img/sidebar-1.jpg";

var params = [];
params['baseUrl'] = 'https://baena.aicor.es/';
params['loginAdminImg'] = loginAdminImg;
params['sideBarIcon'] = iconImg;
params['sideBarImg'] = sideBarImg;
// "purple", "blue", "green", "orange", "red" ... modificar en material-dashboard-react.js
params['sideBarColor'] = 'blue';
params['firstColor'] = '#00622E';
params['proyectName'] = 'Panel Baena';
params['loaderType'] = 'MutatingDots';
params['defaultTableLength'] = 10;
params['tableLengthArray'] = [10, 25, 50];

export default params;
